export default "__VITE_ASSET__Czwb1o5T__"